// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QQrQ","top":"styles_top__1N1Be"};